import React from 'react';
import DataCell from './DataCell';

const cell = {
    textAlign: 'right'
};

const CurrencyDataCell = ({
    rowIndex,
    data,
    accessor,
    scrollPxH,
    scrollPxV,
    isSticky,
    isHighlighted,
    style,
    onHover,
    locale,
    currency,
    rowHeight,
    deleteRowSelected,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false
}) => {
    const formatCurrency = (value) => {
        if (isNaN(value)) return value;

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(value);
    };

    return (
        <DataCell
            rowIndex={rowIndex}
            scrollPxH={scrollPxH}
            scrollPxV={scrollPxV}
            id={`${accessor}${rowIndex}`}
            style={{ height: rowHeight, ...cell, ...style }}
            isSticky={isSticky}
            isHighlighted={isHighlighted}
            deleteRowSelected={deleteRowSelected}
            onHover={onHover}
            highlightedIdx={highlightedIdx}
            setHighlightedIdx={setHighlightedIdx}
            highlightOnClick={highlightOnClick}
        >
            {formatCurrency(data[accessor])}
        </DataCell>
    );
};

export default CurrencyDataCell;
